/**
 * OB Product Card Actions — Compare & Wishlist
 * Handles compare and wishlist buttons on product cards when no app provides the functionality.
 */
if (window.__obProductCardActionsLoaded) return;
window.__obProductCardActionsLoaded = true;

(function () {
  const STORAGE_KEYS = {
    compare: 'ob-compare-products',
    wishlist: 'ob-wishlist-products'
  };

  function getStoredIds(key) {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  function setStoredIds(key, ids) {
    try {
      localStorage.setItem(key, JSON.stringify(ids));
    } catch (e) {
      console.warn('ob-product-card-actions: localStorage write failed', e);
    }
  }

  function showToast(message) {
    const existing = document.getElementById('ob-actions-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'ob-actions-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    toast.style.cssText = 'position:fixed;bottom:1.5rem;left:50%;transform:translateX(-50%);background:#1a1a1a;color:#fff;padding:0.6rem 1.2rem;border-radius:8px;font-size:0.875rem;z-index:9999;box-shadow:0 4px 12px rgba(0,0,0,0.15);transition:opacity 0.3s;';
    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.style.opacity = '1';
    });
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 2500);
  }

  function handleCompare(e) {
    const btn = e.target.closest('[data-ob-compare]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const card = btn.closest('.ob-card, .product-card-wrapper');
    const productId = btn.dataset.productId || card?.querySelector('[data-product-id]')?.dataset?.productId;
    if (!productId) return;

    const ids = getStoredIds(STORAGE_KEYS.compare);
    if (ids.includes(productId)) {
      showToast(document.documentElement.lang?.startsWith('ar') ? 'تمت الإضافة للمقارنة مسبقاً' : 'Already in compare list');
      return;
    }
    ids.push(productId);
    setStoredIds(STORAGE_KEYS.compare, ids);
    showToast(document.documentElement.lang?.startsWith('ar') ? 'تمت الإضافة للمقارنة' : 'Added to compare');
    document.dispatchEvent(new CustomEvent('ob-compare:added', { detail: { productId } }));
  }

  function handleWishlist(e) {
    const el = e.target.closest('.ob-card__wishlist-hook');
    if (!el) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = el.dataset.productId;
    if (!productId) return;

    const ids = getStoredIds(STORAGE_KEYS.wishlist);
    if (ids.includes(productId)) {
      showToast(document.documentElement.lang?.startsWith('ar') ? 'تمت الإضافة للمفضلة مسبقاً' : 'Already in wishlist');
      return;
    }
    ids.push(productId);
    setStoredIds(STORAGE_KEYS.wishlist, ids);
    showToast(document.documentElement.lang?.startsWith('ar') ? 'تمت الإضافة للمفضلة' : 'Added to wishlist');
    document.dispatchEvent(new CustomEvent('ob-wishlist:added', { detail: { productId } }));
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-ob-compare]')) handleCompare(e);
    if (e.target.closest('.ob-card__wishlist-hook')) handleWishlist(e);
  });
})();
